module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent-t1"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_vm._v("The author was born and raised in New Zealand – joining the NZ Army at 16 in order to run away from home. Afterwards, he roamed around Queensland, Australia on construction sites before heading off to London via Johannesburg. In South Africa, he stopped over and hitchhiked around before heading up to Rhodesia, where he eventually found work managing a tobacco farm. The farm lay inside the war zone – and two years later, after several incidents, he joined the BSA Police, where he was involved in the fighting between the government forces and nationalist insurgents until the ceasefire in December 1979. He was awarded the highest police gallantry award.")])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Subsequently, he has mined in Tasmania; rose to senior management in a retail chain in Queensland and Victoria; and has been running his own businesses for the past 20 years. Currently, he is writing and running a small business in Queensland.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7009089a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Author.vue
// module id = 60
// module chunks = 0